import * as turf from '@turf/turf';
// import Datepicker from 'flowbite-datepicker/Datepicker';
import Flickity from '../flickity.pkgd.min.js';

import noUiSlider from 'nouislider';

import { trapFocus } from './focus-trap';

var communityArr = [];
var apartmentArr = [];
var bedsArr = [];
var bathsArr = [];
var bedsExact = false;
var currentMinPrice;
var currentMaxPrice;
var currentDate;
var currentFilterRadius;
var currentCommute;
var priceChange = 0;
const param = new URLSearchParams(window.location.search);
var communityFeatures = [];
var apartmentFeatures = [];

if (param.get('community')) {
    communityFeatures = param.get('community').split('!');
}
if (param.get('apartment')) {
    apartmentFeatures = param.get('apartment').split('!');
}

export const SingleLocations = {
    base_url: $('#base-url').attr('data-url'),
    apiKey: 'pk.eyJ1Ijoid2luZHNvcmNvbW11bml0aWVzIiwiYSI6ImNsMGsyNzRnejBldW4zZGxhZWR2MmszOXIifQ.j0FJT1zbogFAdwLylUnvrQ',
    moreFilterCount: 0,
    bedFilterCount: 0,
    center: false,
    points: window.points,
    actual_points: window.actual_points,
    showLoader() {
        $('.locations-map-loader').removeClass('opacity-0');
    },
    updateFilterCount() {
        $(function () {
            const params = new URLSearchParams(window.location.search);
            let commuArr = [];
            let aptArr = [];

            if (params.get('community')) {
                commuArr = params.get('community').split('!');
                SingleLocations.moreFilterCount += commuArr.length;
            }
            if (params.get('apartment')) {
                aptArr = params.get('apartment').split('!');
                SingleLocations.moreFilterCount += aptArr.length;
            }
        });
    },
    hideLoader() {
        $('.locations-map-loader').addClass('opacity-0');
    },
    setMapHeight() {
        var _h = window.innerHeight;
        var _w = $(window).width();
        var header_h = $('header.header').height();

        var map_height = 396;
        var top_offset = 0;
        if (_w > 991) {
            top_offset = header_h;
            map_height = _h - header_h;
        }
        $('#locations-map').css({
            height: map_height,
            top: top_offset,
        });
    },
    populateMap(map) {
        // Add an image to use as a marker
        map.loadImage(
            SingleLocations.base_url +
                '/wp-content/themes/wincommunities/dist/images/map-box.png',
            (error, image) => {
                if (error) throw error;
                map.addImage('marker-blue', image);
            }
        );
        // Add an image to use as a marker
        map.loadImage(
            SingleLocations.base_url +
                '/wp-content/themes/wincommunities/dist/images/marker-coral.png',
            (error, image) => {
                if (error) throw error;
                map.addImage('marker-coral', image);
            }
        );

        // Add an image to use as a cluster marker
        map.loadImage(
            SingleLocations.base_url +
                '/wp-content/themes/wincommunities/assets/images/cluster-pin.png',
            (error, image) => {
                if (error) throw error;
                map.addImage('cluster-pin', image);
            }
        );

        // Add a GeoJSON source with points
        map.addSource('points', {
            type: 'geojson',
            data: SingleLocations.points,
            cluster: true,
            clusterMaxZoom: 18, // Max zoom to cluster points on
            clusterRadius: 60,
        });

        map.addLayer({
            id: 'cluster-count',
            type: 'symbol',
            source: 'points',
            filter: ['has', 'point_count'],
            layout: {
                'icon-image': 'cluster-pin',
                'icon-allow-overlap': true,
                'text-anchor': 'center',
                'text-field': '{point_count}',
                'text-font': ['Open Sans Bold'],
                'text-size': 14,
                'text-offset': [0, -0.3],
                'text-justify': 'center',
            },
            paint: {
                'text-color': '#000000',
            },
        });

        map.addLayer({
            id: 'windsor_properties',
            type: 'symbol',
            source: 'points',
            filter: ['!', ['has', 'point_count']],
            layout: {
                'icon-image': 'marker-blue',
                'icon-allow-overlap': true,
                'text-field': ['get', 'price'],
                'text-anchor': 'center',
                'text-size': 12,
                'text-offset': [0.25, -0.5],
                'text-font': ['Open Sans Bold'],
            },
            paint: {
                'text-color': '#FFFFFF',
            },
        });

        map.on('click', 'cluster-count', function (e) {
            var features = map.queryRenderedFeatures(e.point, {
                layers: ['cluster-count'],
            });
            var clusterId = features[0].properties.cluster_id;
            map.getSource('points').getClusterExpansionZoom(
                clusterId,
                function (err, zoom) {
                    if (err) return;

                    map.flyTo({
                        center: features[0].geometry.coordinates,
                        zoom: zoom,
                    });
                }
            );
        });

        // Create a popup, but don't add it to the map yet.
        const popup = new mapboxgl.Popup({
            closeButton: true,
            closeOnClick: false,
        });

        let popupCloseTimeout = null;

        // Change the cursor to a pointer when the mouse is over the places layer.
        map.on('mouseenter', 'windsor_properties', (e) => {
            const props = e.features[0].properties;
            const coordinates = e.features[0].geometry.coordinates.slice();
            const title = props.title;
            const link = props.link;
            const phone_number = props.phone_number;
            const address = props.address;
          
            // 🛠 Get selected beds from URL
            const selectedBedKeys = SingleLocations.getSelectedBedsFromURL();
          
            // 🧮 Determine lowest price for selected beds
            let price = null;
            const prices = [];
          
            selectedBedKeys.forEach(bed => {
              const key = bed === 'studio' ? 'min_studio' : `min_${bed}`;
              if (props[key] && !isNaN(parseInt(props[key]))) {
                prices.push(parseInt(props[key]));
              }
            });
          
            if (prices.length > 0) {
              price = `$${Math.min(...prices).toLocaleString()}+`;
            } else if (props.minPrice && props.minPrice > 0) {
              price = `$${parseInt(props.minPrice).toLocaleString()}+`;
            } else if (props.price) {
              price = props.price;
            } else {
              price = e.features[0].properties.price;
            }
          
            // Wrap coordinates
            while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
              coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
            }
          
            map.getCanvas().style.cursor = 'pointer';
            clearPopupCloseTimeout();
            popup.remove();
          
            popup
              .setLngLat(coordinates)
              .setHTML(
                `<div>
                  <span class="block font-nunito-sans font-extrabold text-xl text-brand-md-blue mb-2 price-pop">${price}</span>
                  <span class="block font-playfair text-2xl text-brand-primary mb-2">${title}</span>
                  <span class="block font-nunito-sans text-base text-black mb-2">${address}</span>
                  <span class="block font-nunito-sans font-extrabold text-base text-brand-neutral-gray mb-4">
                    <a class="!text-brand-neutral-dk-gray" href="tel:${phone_number}">${phone_number}</a>
                  </span>
                  <a class="no-underline block text-center py-1 text-brand-md-blue text-base capitalize font-nunito-sans font-extrabold border-2 border-brand-md-blue rounded-full" href="${link}">View More</a>
                </div>`
              )
              .addTo(map);
          
            $(popup._closeButton).attr('tabindex', '-1');
        });

        // Change the cursor to a pointer when the mouse is over the places layer.
        map.on('touchstart', 'windsor_properties', (e) => {
            map.getCanvas().style.cursor = 'pointer';
            const props = e.features[0].properties;
            const coordinates = e.features[0].geometry.coordinates.slice();
            const title = e.features[0].properties.title;
            const link = e.features[0].properties.link;
            // const price = e.features[0].properties.price;
            const phone_number = e.features[0].properties.phone_number;
            const address = e.features[0].properties.address;

            // 🛠 Get selected beds from URL
            const selectedBedKeys = SingleLocations.getSelectedBedsFromURL();
          
            // 🧮 Determine lowest price for selected beds
            let price = null;
            const prices = [];
          
            selectedBedKeys.forEach(bed => {
              const key = bed === 'studio' ? 'min_studio' : `min_${bed}`;
              if (props[key] && !isNaN(parseInt(props[key]))) {
                prices.push(parseInt(props[key]));
              }
            });
          
            if (prices.length > 0) {
              price = `$${Math.min(...prices).toLocaleString()}+`;
            } else if (props.minPrice && props.minPrice > 0) {
              price = `$${parseInt(props.minPrice).toLocaleString()}+`;
            } else if (props.price) {
              price = props.price;
            } else {
              price = e.features[0].properties.price;
            }

            // Ensure that if the map is zoomed out such that multiple
            // copies of the feature are visible, the popup appears
            // over the copy being pointed to.
            while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
            }

            popup
                .setLngLat(coordinates)
                .setHTML(
                    `<div><span class="block font-nunito-sans font-extrabold text-xl text-brand-md-blue mb-2 price-pop">${price}</span>
                        <span class="block font-playfair text-2xl text-brand-primary mb-2">${title}</span>
                        <span class="block font-nunito-sans  text-base text-black mb-2">${address}</span>
                        <span class="block font-nunito-sans font-extrabold text-base text-brand-neutral-gray mb-4"><a class="!text-brand-neutral-dk-gray" href="tel:${phone_number}">${phone_number}</a></span>
                        <a class="no-underline block text-center py-1 text-brand-md-blue text-base capitalize font-nunito-sans font-extrabold border-2 border-brand-md-blue rounded-full" href="${link}">View More</a></div>`
                )
                .addTo(map);
            var mapboxCloseButton = $(popup._closeButton);
            mapboxCloseButton.attr('tabindex', '-1');
        });

        map.on('click', 'windsor_properties', (e) => {
            const coordinates = e.features[0].geometry.coordinates.slice();

            //tell the map to center on the marker coordinates
            const zoom = map.getZoom();
            let zoomTo = zoom < 6 ? 9 : zoom;
            map.flyTo({
                center: coordinates,
                zoom: zoomTo,
                speed: 0.7,
                duration: 1000,
            });
        });

        const closePopupWithTimeout = () => {
            popupCloseTimeout = setTimeout(() => popup.remove(), 3000);
        };

        const clearPopupCloseTimeout = () => {
            if (popupCloseTimeout) {
                clearTimeout(popupCloseTimeout);
                popupCloseTimeout = null;
            }
        };

        // Change it back to a pointer when it leaves.
        map.on('mouseleave', 'windsor_properties', () => {
            map.getCanvas().style.cursor = '';
            closePopupWithTimeout();
        });

        // Change it back to a pointer when it touches another place.
        map.on('touchend', 'points', () => {
            map.getCanvas().style.cursor = '';
        });

        // When hover through the properties
        $('.a-property').on('mouseover', function (e) {
            if ($(window).width() > 768 && $(window).height() > 650) {
                SingleLocations.centerMap(map);
                map.setZoom(10);
        
                const lat = $(this).data('lat');
                const lng = $(this).data('lng');
                const coordinates = [lng, lat];
        
                map.getCanvas().style.cursor = 'pointer';
        
                const $data = $(this).find('.property_data');
                const $priceVal = $(this).find('.price-val');
        
                const title = $data.text();
                const link = $data.attr('href');
                const phone_number = $data.data('phone');
                const address = $data.data('address');
        
                // ✅ Get selected beds from URL
                const selectedBedKeys = new URLSearchParams(window.location.search).get('beds')?.split(',') || [];
        
                // ✅ Look through data-min-* attrs
                const prices = [];
                selectedBedKeys.forEach(bed => {
                    const key = bed === 'studio' ? 'studio' : bed;
                    const val = $priceVal.data(`min-${key}`);
                    if (val && !isNaN(parseInt(val))) {
                        prices.push(parseInt(val));
                    }
                });
        
                let displayPrice;
                if (prices.length > 0) {
                    displayPrice = `$${Math.min(...prices).toLocaleString()}+`;
                } else {
                    const fallback = $priceVal.data('price');
                    displayPrice = fallback ? `$${parseInt(fallback).toLocaleString()}+` : '$0+';
                }
        
                popup
                    .setLngLat(coordinates)
                    .setHTML(
                        `<div>
                            <span class="block font-nunito-sans font-extrabold text-xl text-brand-md-blue mb-2 price-pop">${displayPrice}</span>
                            <span class="block font-playfair text-2xl text-brand-primary mb-2">${title}</span>
                            <span class="block font-nunito-sans text-base text-black mb-2">${address}</span>
                            <span class="block font-nunito-sans font-extrabold text-base text-brand-neutral-gray mb-4">
                                <a class="!text-brand-neutral-dk-gray" href="tel:${phone_number}">${phone_number}</a>
                            </span>
                            <a class="no-underline block text-center py-1 text-brand-md-blue text-base capitalize font-nunito-sans font-extrabold border-2 border-brand-md-blue rounded-full" href="${link}">View More</a>
                        </div>`
                    )
                    .addTo(map);
        
                const mapboxCloseButton = $(popup._closeButton);
                mapboxCloseButton.attr('tabindex', '-1');
            }
        });
        
        
        $('.a-property').on('mouseout', function (e) {
            map.getCanvas().style.cursor = '';
            $('.mapboxgl-popup-close-button').trigger('click');
        });
    },
    centerMap(map) {
        if (
            SingleLocations.actual_points &&
            SingleLocations.actual_points.features
        ) {
            var bounds = new mapboxgl.LngLatBounds();
            SingleLocations.actual_points.features.forEach(function (feature) {
                bounds.extend(feature.geometry.coordinates);
            });
            map.fitBounds(bounds, {
                padding: 100,
                duration: 0,
                maxZoom: 10,
            });
        }
    },
    jumpLinks() {
        $('a.jump-link').on('click', function (e) {
            e.preventDefault();
            var header_h = $('header.header').height();

            var target = this.hash,
                $target = $(target);

            $('html, body')
                .stop()
                .animate(
                    { scrollTop: $target.offset().top - header_h },
                    700,
                    'swing'
                );
            return false;
        });
    },
    updateUrlParam(name, value) {
        const params = new URLSearchParams(window.location.search);
        params.set(name, value);
        window.history.replaceState(
            {},
            '',
            `${window.location.pathname}?${params}`
        );
    },
    removeUrlParam(name) {
        const params = new URLSearchParams(window.location.search);
        params.delete(name);
        window.history.replaceState(
            {},
            '',
            `${window.location.pathname}?${params}`
        );
    },
    getDistanceFromLatLon(location_coords, commute_coords) {
        var R = 3963; // Radius of the earth in miles
        var dLat = SingleLocations.deg2rad(
            commute_coords[1] - location_coords[1]
        );
        var dLon = SingleLocations.deg2rad(
            commute_coords[0] - location_coords[0]
        );
        var a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(SingleLocations.deg2rad(location_coords[1])) *
                Math.cos(SingleLocations.deg2rad(commute_coords[1])) *
                Math.sin(dLon / 2) *
                Math.sin(dLon / 2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        var d = R * c; // Distance in miles
        return d;
    },
    deg2rad(deg) {
        return deg * (Math.PI / 180);
    },
    getSelectedBedsFromURL() {
        const params = new URLSearchParams(window.location.search);
        const bedParam = params.get('beds');
        if (!bedParam) return [];
        return bedParam.split(',').map(bed => bed.trim());
    },      
    runFilterBasedOnURL(map, source = '') {
        const radius = Math.round(
            $('#commute-slider .noUi-handle').attr('aria-valuenow')
        );
        const location_id = $('.property-search__results').attr(
            'data-location-id'
        );
        const params = new URLSearchParams(window.location.search);

        let filters = {};
        filters.location_id = location_id;

        if (params.get('price')) {
            filters.price = params.get('price');
        }
        if (params.get('date')) {
            filters.date = params.get('date');
        }
        if (params.get('beds')) {
            filters.beds = params.get('beds').split(',');
            bedsArr = filters.beds;
        } else {
            bedsArr = [];
        }
        if (params.get('beds-exact')) {
            filters['beds-exact'] = params.get('beds-exact');
            bedsExact = filters['beds-exact'];
        }
        if (params.get('community')) {
            filters.community = params.get('community');
            communityArr = filters.community.split('!');
        }
        if (params.get('apartment')) {
            filters.apartment = params.get('apartment');
            apartmentArr = filters.apartment.split('!');
            communityArr = communityArr.concat(apartmentArr);
        }
        if (params.get('commute')) {
            currentCommute = params.get('commute');
        }
        if (params.get('baths')) {
            filters.baths = params.get('baths').split(',');
            bathsArr = filters.baths;
        }
        if (params.get('order')) {
            $('#sort-result').val(params.get('order'));
        } else {
            $('#sort-result').val('ASC');
        }
        var page = 1;
        if (params.get('_page')) {
            page = params.get('_page');
        }
        //SingleLocations.showLoader();
        $.ajax({
            type: 'POST',
            url: SingleLocations.base_url + '/wp-admin/admin-ajax.php',
            data: {
                action: 'filter_location_properties',
                filters: filters,
            },
            beforeSend: function () {
                if (source == '')
                    $('.autocomplete-loading').addClass('is-loading');
            },
            success: function (response) {
                var data = JSON.parse(response);

                // filter out by commute
                if (SingleLocations.commutePin) {
                    var ids = [];
                    $.each(data, function () {
                        var property = $('.a-property[data-id=' + this + ']');
                        var lng = property.attr('data-lng') * 1;
                        var lat = property.attr('data-lat') * 1;

                        const distance = SingleLocations.getDistanceFromLatLon(
                            SingleLocations.commutePin.geometry.coordinates,
                            [lng, lat]
                        );

                        if (distance <= radius) {
                            ids.push(this);
                        }
                    });
                    SingleLocations.updateLocations(map, ids, page);
                } else {
                    SingleLocations.updateLocations(map, data, page);
                }
                $('.autocomplete-loading').removeClass('is-loading');
                if (window.location.pathname.includes('/apartments/')) {
                    SingleLocations.updatePriceValText(bedsArr);
                    SingleLocations.updateBedroomLabels(bedsArr, map);
                    SingleLocations.sortProperties();
                }
            },
            error: function () {
                $('.autocomplete-loading').removeClass('is-loading');
            },
            complete: function () {
                //SingleLocations.hideLoader();
                $('.autocomplete-loading').removeClass('is-loading');
                $('.property-loading').addClass('hidden');
            },
        });
    },
    sortProperties() {
        const params = new URLSearchParams(window.location.search);
        const order = params.get('order')?.toUpperCase() === 'DESC' ? 'DESC' : 'ASC';
        const beds = params.get('beds')?.split(',') || [];

        const parent = document.querySelector('.location-property-list');
        if (!parent) return;

        const allChildren = Array.from(parent.children);

        const isSortable = (el) =>
            el.classList.contains('a-property-wrap') &&
            !el.classList.contains('is-featured') &&
            !el.querySelector('.a-custom-card') &&
            !el.querySelector('.a-facet-card');

        let blocks = allChildren.filter(isSortable);

        // 🔄 Bubble-style in-place comparison & swap
        for (let i = 0; i < blocks.length - 1; i++) {
            for (let j = i + 1; j < blocks.length; j++) {
                const a = blocks[i];
                const b = blocks[j];

                const priceA = getBedFilteredPrice(a, beds);
                const priceB = getBedFilteredPrice(b, beds);

                const shouldSwap = order === 'ASC' ? priceA > priceB : priceA < priceB;

                if (shouldSwap) {
                    const next = b.nextSibling;
                    parent.insertBefore(b, a);
                    parent.insertBefore(a, next);
                    [blocks[i], blocks[j]] = [blocks[j], blocks[i]];
                }
            }
        }

        // Helper function to get the min price based on selected beds
        function getBedFilteredPrice(el, bedKeys) {
            const $el = el.querySelector('.price-val');
            const prices = [];

            bedKeys.forEach(bed => {
                const key = bed === 'studio' ? 'min-studio' : `min-${bed}`;
                const val = $el?.dataset[key];
                if (val && !isNaN(parseInt(val))) {
                    prices.push(parseInt(val));
                }
            });

            if (prices.length > 0) {
                return Math.min(...prices);
            }

            // Fallback to base price
            const fallback = $el?.dataset.price;
            return fallback && !isNaN(parseInt(fallback)) ? parseInt(fallback) : 9999999;
        }
    },
    updatePriceValText(selectedBeds) {
        const priceValEls = document.querySelectorAll('.price-val');
      
        priceValEls.forEach(el => {
          const prices = [];
      
          selectedBeds.forEach(bed => {
            const key = bed === 'studio' ? 'studio' : bed; // handles 0 as 'studio'
            const dataAttr = `data-min-${key}`;
            const value = el.getAttribute(dataAttr);
      
            if (value && !isNaN(parseInt(value))) {
              prices.push(parseInt(value));
            }
          });
          if (prices.length > 0) {
            const min = Math.min(...prices);
            el.textContent = `$${min.toLocaleString()}+`;
          } else {
            // fallback to default price attribute
            const fallback = el.getAttribute('data-price');
            el.textContent = fallback ? `$${parseInt(fallback).toLocaleString()}+` : 'Price Unavailable';
          }
        });
    },
    updateBedroomLabels(selectedBedKeys, map) {
        console.log('updateBedroomLabels called with:', selectedBedKeys);
        
        const pointsSource = map.getSource("points");
        if (!pointsSource || !SingleLocations.points) {
            console.log('No points source or points data available');
            return;
        }
    
        const originalData = SingleLocations.points;
        console.log('Original features count:', originalData.features.length);
    
        // No filters: reset to original data and label
        if (!Array.isArray(selectedBedKeys) || selectedBedKeys.length === 0) {
            console.log('No bedroom filters, resetting to original data');
            map.setLayoutProperty("windsor_properties", "text-field", ["get", "price"]);
            pointsSource.setData(originalData);
            return;
        }
    
        // Generate formatted label
        const priceExpression = SingleLocations.getPriceLabelExpression(selectedBedKeys);
        map.setLayoutProperty("windsor_properties", "text-field", priceExpression);
    
        // Filter the GeoJSON features
        const filteredFeatures = originalData.features.filter(feature => {
            const props = feature.properties;
            console.log('Checking feature:', props.title);
            
            // Check if any of the selected bedroom types have valid prices
            const hasValidBedroomPrice = selectedBedKeys.some(key => {
                const priceKey = key === 'studio' ? 'min_studio' : `min_${key}`;
                const price = props[priceKey];
                console.log(`Raw ${priceKey} value:`, price);
                
                if (price === undefined || price === null || price === '') {
                    console.log(`${priceKey} is not available`);
                    return false;
                }
                
                const numPrice = parseInt(price);
                const isValid = !isNaN(numPrice) && numPrice > 0 && numPrice !== 9999999;
                console.log(`${priceKey} parsed value:`, numPrice, 'isValid:', isValid);
                return isValid;
            });
            
            console.log('Has valid bedroom price:', hasValidBedroomPrice);
            return hasValidBedroomPrice;
        });
    
        console.log('Filtered features count:', filteredFeatures.length);
    
        // Build filtered dataset
        const filteredData = {
            ...originalData,
            features: filteredFeatures
        };
    
        // Update source data with filtered features
        pointsSource.setData(filteredData);
        
        // Force update the map
        map.setLayoutProperty("windsor_properties", "visibility", "none");
        setTimeout(() => {
            map.setLayoutProperty("windsor_properties", "visibility", "visible");
        }, 100);
    },    
    getPriceLabelExpression(bedroomKeys) {
        const keys = Array.isArray(bedroomKeys) ? bedroomKeys : [];
      
        // Create price expressions for each bedroom type
        const priceExpressions = keys.map(key => {
            const priceKey = key === 'studio' ? 'min_studio' : `min_${key}`;
            return [
                "case",
                ["all", 
                    ["has", priceKey],
                    ["!=", ["get", priceKey], 0],
                    ["!=", ["get", priceKey], 9999999],
                    ["!=", ["get", priceKey], ""]
                ],
                ["to-number", ["get", priceKey]],
                9999999
            ];
        });

        // Get the minimum valid price
        const resolvedPrice = ["min", ...priceExpressions];
      
        const isUnavailable = [
            "any",
            ["==", resolvedPrice, 0],
            ["==", resolvedPrice, 9999999],
            ["!=", ["typeof", resolvedPrice], "number"]
        ];
      
        return [
            "case",
            isUnavailable,
            ["get", "price"], // fallback to the preformatted 'price' string
            [
                "format",
                "$",
                {},
                [
                    "to-string",
                    [
                        "number-format",
                        resolvedPrice,
                        {
                            "min-fraction-digits": 0,
                            "max-fraction-digits": 0,
                            "locale": "en-US"
                        }
                    ]
                ],
                {},
                "+",
                {}
            ]
        ];
    },   

    toggleFilter() {
        $('.search-filter-toggle a').on('click', function () {
            var $button = $(this).parent();
            var filter_type = $button.data('filter');
            var $ctrl = $('.search-filter[data-filter=' + filter_type + ']');
            console.log($ctrl);

            $button.addClass('is-open').siblings().removeClass('is-open');
            $ctrl.attr('open', true).siblings().attr('open', false);

            trapFocus(
                document.querySelector(
                    '.search-filter[data-filter=' + filter_type + ']'
                )
            );

            if (filter_type === 'features') {
                if ($button.hasClass('is-active')) {
                    $ctrl
                        .find('input[type=checkbox]')
                        .filter(function (index, item2) {
                            item2.checked = false;
                            return communityArr.includes(item2.value);
                        })
                        .map((index, finalItem) => (finalItem.checked = true));
                }
            }

            if (filter_type === 'beds') {
                const params = new URLSearchParams(window.location.search);
                if (params.get('beds-exact')) {
                    bedsExact = true;
                } else {
                    bedsExact = false;
                }
                if ($button.hasClass('is-active')) {
                    $('.bed-button').removeClass('is-active');
                    $('.bed-button[data-num-beds="' + bedsArr + '"]').addClass(
                        'is-active'
                    );
                }
                if (!bedsExact) {
                    $('.beds-exact').prop('checked', false);
                    $('.bed-button span.plus').removeClass('hidden');
                    $('.bed-button.is-active').nextAll().addClass('is-active');
                } else {
                    $('.beds-exact').prop('checked', true);
                    $('.bed-button span.plus').addClass('hidden');
                    $('.bed-button.is-active')
                        .nextAll()
                        .removeClass('is-active');
                }
            }

            if (filter_type === 'price') {
                if ($button.hasClass('is-active')) {
                    // console.log(document.getElementById('price-slider'));
                    document
                        .getElementById('price-slider')
                        .noUiSlider.set([currentMinPrice, currentMaxPrice]);
                    // trapFocus(document.getElementById('price-slider'));
                }
            }

            if (filter_type === 'date') {
                if ($button.hasClass('is-active')) {
                    const params = new URLSearchParams(window.location.search);
                    const currentDateparam = params.get('date');
                    const slctDate = $('#slcted-date').val();
                    if (currentDateparam) {
                        $('#date-filter').val(
                            new Date(currentDateparam).toLocaleDateString(
                                'en-US',
                                {
                                    year: 'numeric',
                                    month: '2-digit',
                                    day: '2-digit',
                                }
                            )
                        );
                    }
                    if (slctDate) {
                        $('#date-filter').val(
                            new Date(slctDate).toLocaleDateString('en-US', {
                                year: 'numeric',
                                month: '2-digit',
                                day: '2-digit',
                            })
                        );
                    }
                }
            }
            if (filter_type === 'commute') {
                if ($button.hasClass('is-active')) {
                    document
                        .getElementById('commute-slider')
                        .noUiSlider.set(currentFilterRadius);
                    if (
                        currentCommute != undefined &&
                        currentCommute.length > 0
                    ) {
                        $('#geocoder')
                            .find('input[type="text"]')
                            .val(decodeURIComponent(currentCommute));
                    } else {
                        $('#geocoder').find('input[type="text"]').val('');
                    }
                }
            }

            var top = 0;
            top = $button.position().top;
            top += $button.height();
            var middlePos = $(window).width() / 2 - $ctrl.innerWidth() / 2;
            if ($('#wpadminbar').length > 0) {
                top += $('#wpadminbar').height();
            }
            top += 7;

            var left = 0;

            if ($(window).width() > 767) {
                left = $button.position().left;
            } else {
                // left = 20+'%';
                left = middlePos;
            }

            $ctrl.css({ top, left });

            return false;
        });

        $(
            '.search-filter-toggle[data-filter=date] a, .search-filter-toggle[data-filter=price] a'
        ).on('keydown', function (event) {
            if (event.key === 'Enter') {
                $(this).click();
            }
        });

        $('.search-filter__close').on('click', function () {
            var $ctrl = $(this).parents('.search-filter');
            var filter_type = $ctrl.data('filter');
            var $button = $(
                '.search-filter-toggle[data-filter=' + filter_type + ']'
            );
            $button.removeClass('is-open');
            $ctrl.attr('open', false);
            $('.datepicker').addClass('hidden');

            if (!$button.hasClass('is-active')) {
                $(
                    '[data-filter=' + filter_type + '] .search-filter__reset'
                ).trigger('click');
            }
            $(
                '.search-filter-toggle[data-filter=' + filter_type + '] a'
            ).focus();
            return false;
        });

        $(window).on('resize', SingleLocations.closeFilters);

        $('.datepicker-input').on('focus', function () {
            $('.ui-datepicker').hide();
        });
    },
    poiSlider() {
        if ($('.poi-slider').length > 0) {
            // Initialize Flickity
            var poiSlider = new Flickity(
                document.querySelector('.poi-slider'),
                {
                    cellSelector: '.slide',
                    pageDots: false,
                    wrapAround: true,
                    selectedAttraction: 0.1,
                    friction: 1,
                    prevNextButtons: false,
                    cellAlign: 'left',
                }
            );

            // Move to the next slide on button click
            document
                .querySelector('.pois-next')
                .addEventListener('click', function (e) {
                    e.preventDefault();
                    poiSlider.next();
                    document
                        .querySelector('.poi-slider .is-selected')
                        .setAttribute('tabindex', 0);
                    document.querySelector('.poi-slider .is-selected').focus();
                });

            // Move to the previous slide on button click
            document
                .querySelector('.pois-prev')
                .addEventListener('click', function (e) {
                    e.preventDefault();
                    poiSlider.previous();
                });

            // Resize Flickity on window load and resize
            window.addEventListener('load', function () {
                poiSlider.resize();
            });
            window.addEventListener('resize', function () {
                poiSlider.resize();
            });
        }
    },

    filterPrice(map) {
        if (!$('.in-page-search-filter').length) {
            if ($('#price-slider').length < 1) return;
            var filterPriceMin = document.getElementById('filter-price-min');
            var filterPriceMax = document.getElementById('filter-price-max');
            var min = 900;
            var max = 50000;
            var start_min = filterPriceMin.value ? filterPriceMin.value : min;
            var start_max = filterPriceMax.value ? filterPriceMax.value : max;
            // var min = 800;
            // var max = 9000;
            var slider = document.getElementById('price-slider');
            noUiSlider.create(slider, {
                start: [start_min, start_max],
                connect: true,
                step: 5,
                range: {
                    min: min,
                    max: max,
                },
                format: {
                    to: function (value) {
                        return Math.round(value);
                    },
                    from: function (value) {
                        return Math.round(value);
                    },
                },
            });

            // handle interaction
            slider.noUiSlider.on('update', function (values, handle) {
                if (priceChange == 1) {
                    if (handle == 0) {
                        filterPriceMin.value = values[handle];
                    }
                    if (handle == 1) {
                        filterPriceMax.value = values[handle];
                    }
                }
            });
            filterPriceMin.addEventListener('change', function () {
                if (this.value != '') {
                    priceChange = 1;
                }
                slider.noUiSlider.set([this.value, null]);
            });
            filterPriceMax.addEventListener('change', function () {
                if (this.value != '') {
                    priceChange = 1;
                }
                slider.noUiSlider.set([null, this.value]);
            });

            // handle apply
            $('[data-filter=price] .search-filter__apply').on(
                'click',
                function () {
                    $('.search-filter-toggle').removeClass('is-open');
                    $('.search-filter').attr('open', false);

                    currentMinPrice = filterPriceMin.value;
                    currentMaxPrice = filterPriceMax.value;
                    if (currentMinPrice != '' && currentMaxPrice != '') {
                        $('.search-filter-toggle[data-filter=price]').addClass(
                            'is-active'
                        );
                        SingleLocations.updateUrlParam(
                            'price',
                            filterPriceMin.value + ':' + filterPriceMax.value
                        );
                        SingleLocations.runFilterBasedOnURL(map);
                        SingleLocations.generateToken(
                            'price',
                            '$' + currentMinPrice + ' - $' + currentMaxPrice
                        );
                    }

                    $('.search-filter-toggle[data-filter=price] a').focus();
                    return false;
                }
            );
            $('.property-load-more').on('click', function () {
                $('.property-loading').removeClass('hidden');
                $('.property-load-more').hide();
                var curPage = $('#curPage').val();
                curPage++;
                $('#curPage').val(curPage);
                SingleLocations.updateUrlParam('_page', curPage);
                SingleLocations.runFilterBasedOnURL(map, 'load-more');
                return false;
            });

            // handle reset
            $('[data-filter=price] .search-filter__reset').on(
                'click',
                function () {
                    SingleLocations.resetPrice();
                    SingleLocations.runFilterBasedOnURL(map);
                    $('#search-token-price').remove();
                    return false;
                }
            );
        }
    },
    resetPrice() {
        var filterPriceMin = document.getElementById('filter-price-min');
        var filterPriceMax = document.getElementById('filter-price-max');
        var slider = document.getElementById('price-slider');
        var min = 900;
        var max = 50000;
        priceChange = 0;

        filterPriceMin.value = '';
        filterPriceMax.value = '';
        slider.noUiSlider.set([min, max]);

        $('[data-filter=price]').removeClass('is-active');
        SingleLocations.removeUrlParam('price');
    },
    filterDate(map) {
        if (!$('.in-page-search-filter').length) {
            // handle apply
            $('[data-filter=date] .search-filter__apply').on(
                'click',
                function () {
                    $('.search-filter-toggle').removeClass('is-open');
                    $('.search-filter').attr('open', false);

                    var date = $('#date-filter').val();
                    // $('#date-filter').datepicker('setDate', date);
                    currentDate = date;
                    if (date) {
                        var date_array = date.split('/');
                        var date_formatted =
                            date_array[2] +
                            '-' +
                            date_array[0] +
                            '-' +
                            date_array[1];

                        $('.search-filter-toggle[data-filter=date]').addClass(
                            'is-active'
                        );
                        SingleLocations.updateUrlParam('date', date_formatted);
                        SingleLocations.runFilterBasedOnURL(map);
                        SingleLocations.generateToken('date', date);
                    }

                    $('.search-filter-toggle[data-filter=date] a').focus();

                    return false;
                }
            );

            // handle reset
            $('[data-filter=date] .search-filter__reset').on(
                'click',
                function () {
                    SingleLocations.resetDate();
                    $('#search-token-date').remove();
                    SingleLocations.runFilterBasedOnURL(map);
                    return false;
                }
            );
        }
    },
    resetDate() {
        var date = $('#date-filter').val('');

        $('.search-filter-toggle[data-filter=date]').removeClass('is-active');
        SingleLocations.removeUrlParam('date');
    },
    toggleExactBeds() {
        var exact = $('.beds-exact').is(':checked');
        if (exact) {
            $('.bed-button span.plus').addClass('hidden');
            $('.bed-button.is-active').nextAll().removeClass('is-active');
        } else {
            $('.bed-button span.plus').removeClass('hidden');
            $('.bed-button.is-active').nextAll().addClass('is-active');
        }
    },
    filterByBeds() {
        $('.filter_by_bedroom').on('click', function () {
            //var checkedBed = 3;
            var checkedBed = $(
                '.facet-cards-div .bed-filter-check.is-active'
            ).data('value');
            $('.search-filter .bed-check a').removeClass('is-active');
            $(
                '.more-filter-content .advanced-filter-facet.bed-check'
            ).removeClass('is-active');
            if (checkedBed == 3) {
                $(
                    '.search-filter .bed-check [data-value="' +
                        checkedBed +
                        '"]'
                ).addClass('is-active');
                $('.search-filter .bed-check [data-value="4"]').addClass(
                    'is-active'
                );
                $(
                    '.more-filter-content .advanced-filter-facet.bed-check[data-value="' +
                        checkedBed +
                        '"]'
                ).addClass('is-active');
                $(
                    '.more-filter-content .advanced-filter-facet.bed-check[data-value="4"]'
                ).addClass('is-active');
            } else {
                $(
                    '.search-filter .bed-check [data-value="' +
                        checkedBed +
                        '"]'
                ).addClass('is-active');
                $(
                    '.more-filter-content .advanced-filter-facet.bed-check[data-value="' +
                        checkedBed +
                        '"]'
                ).addClass('is-active');
            }
            $('[data-filter=beds] .search-filter__apply').trigger('click');
        });
    },
    closeMapPopup() {
        $(
            '.search-filter__apply, .search-filter__reset, .advanced-search-btn, .advanced-apply'
        ).on('click', function (event) {
            SingleLocations.removeUrlParam('_page');
            $('#curPage').val(1);
            $('.mapboxgl-popup-close-button').trigger('click');
        });
    },
    filterBeds(map) {
        if (!$('.in-page-search-filter').length) {
            $('.bed-check .advanced-filter-facet').on('click', function (e) {
                var _facetVal = $(this).data('value');
                if ($(this).data('value') == 3 || $(this).data('value') == 4) {
                    _facetVal = 3;
                }

                if ($(this).hasClass('is-active')) {
                    $(
                        '.bed-check [data-value="' +
                            $(this).data('value') +
                            '"]'
                    ).addClass('is-active');
                    $(
                        '.facet-cards-div .bed-filter-check[data-value="' +
                            _facetVal +
                            '"]'
                    ).addClass('is-active');
                } else {
                    $(
                        '.bed-check [data-value="' +
                            $(this).data('value') +
                            '"]'
                    ).removeClass('is-active');
                    if (
                        !$(
                            '.bed-check .advanced-filter-facet[data-value="3"]'
                        ).hasClass('is-active') &&
                        !$(
                            '.bed-check .advanced-filter-facet[data-value="4"]'
                        ).hasClass('is-active')
                    )
                        $(
                            '.facet-cards-div .bed-filter-check[data-value="' +
                                _facetVal +
                                '"]'
                        ).removeClass('is-active');
                }
            });
            $('[data-filter=beds] .search-filter__apply').on(
                'click',
                function () {
                    $('.search-filter-toggle').removeClass('is-open');
                    $('.search-filter').attr('open', false);
                    var checkedBed = $('.search-filter .bed-check .is-active');
                    var num_beds = [];
                    $('.bed-tokens').remove();
                    checkedBed.each(function () {
                        num_beds.push($(this).data('value'));
                        var value = '';
                        var key = '';
                        if ($(this).data('value') == 'studio') {
                            value = 'Studio';
                            key = 'bed-studio';
                        } else if ($(this).data('value') == '3') {
                            value = '3+ Beds';
                            key = 'bed-3';
                        } else {
                            if ($(this).data('value') == 1) {
                                value = $(this).data('value') + ' Bed';
                            } else {
                                value = $(this).data('value') + ' Beds';
                            }
                            key = 'bed-' + $(this).data('value');
                        }
                        SingleLocations.generateToken(key, value, 'bed-tokens');
                    });
                    if (num_beds.length) {
                        $('.search-filter-toggle[data-filter=beds]').addClass(
                            'is-active'
                        );
                        SingleLocations.updateUrlParam(
                            'beds',
                            num_beds.join(',')
                        );
                    } else {
                        SingleLocations.removeUrlParam('beds');
                    }

                    SingleLocations.runFilterBasedOnURL(map);

                    $('.search-filter-toggle[data-filter=beds] a').focus();

                    return false;
                }
            );

            $('[data-filter=beds] .search-filter__reset').on(
                'click',
                function () {
                    SingleLocations.resetBeds();
                    SingleLocations.runFilterBasedOnURL(map);

                    return false;
                }
            );

            $('[data-filter=beds] .search-filter__close').on(
                'click',
                function () {
                    var checkedBed = [];
                    $('.bed-tokens').each(function () {
                        checkedBed.push($(this).find('span').text());
                    });

                    var newBeds = $('.bed-check');
                    newBeds.each(function () {
                        var bed = $.trim($(this).text());
                        if (!checkedBed.includes(bed)) {
                            $(this).removeClass('is-active');
                        } else {
                            $(this).addClass('is-active');
                        }
                    });

                    return false;
                }
            );
            $('.more-filters-close-btn').on('click', function () {
                var checkedBed = [];
                $('.bed-tokens').each(function () {
                    checkedBed.push($(this).find('span').text());
                });

                var newBeds = $('.bed-check');

                newBeds.each(function () {
                    var bed = $.trim($(this).text());
                    if (!checkedBed.includes(bed)) {
                        $(this).removeClass('is-active');
                    } else {
                        $(this).addClass('is-active');
                    }
                });

                var checkedBath = [];
                $('.bath-tokens').each(function () {
                    checkedBath.push($(this).find('span').text());
                });

                var newBaths = $('.bath-check .advanced-filter-facet');
                newBaths.each(function () {
                    var bath = $.trim($(this).text());
                    if (!checkedBath.includes(bath)) {
                        $(this).removeClass('is-active');
                    } else {
                        $(this).addClass('is-active');
                    }
                });
                var communities = $(
                    '.community-amenity-filter .advanced-filter-facet'
                );
                communities.each(function () {
                    var community = $(this).data('value');
                    if (
                        !communityFeatures.includes(community) &&
                        !communityFeatures.includes(community + '')
                    ) {
                        $(this).removeClass('is-active');
                    } else {
                        $(this).addClass('is-active');
                    }
                });

                var apartments = $(
                    '.apartment-amenity-filter .advanced-filter-facet'
                );

                apartments.each(function () {
                    var apartment = $(this).data('value');
                    if (
                        !apartmentFeatures.includes(apartment) &&
                        !apartmentFeatures.includes(apartment + '')
                    ) {
                        $(this).removeClass('is-active');
                    } else {
                        $(this).addClass('is-active');
                    }
                });

                $(
                    '.search-filter-toggle[data-filter=more-filters] button'
                ).focus();

                return false;
            });
        }
    },
    resetBeds() {
        $('.num-beds .bed-button').removeClass('is-active');
        $('.beds-exact').prop('checked', false);

        $('.bed-check .bg-checkbox-default').removeClass('is-active');
        $('.bed-tokens').remove();
        SingleLocations.removeUrlParam('beds');
    },
    filterBaths(map) {
        var checkedBath = $('.bath-check .is-active');
        var num_baths = [];
        $('.bath-tokens').remove();
        checkedBath.each(function () {
            num_baths.push($(this).data('value'));
            var value = '';
            if ($(this).data('value') == 1) {
                value = $(this).data('value') + ' Bath';
            } else {
                value = $(this).data('value') + ' Baths';
            }
            var key = 'bath-' + $(this).data('value');
            if ($(this).data('value') == '3') {
                value = '3+ Baths';
                key = 'bath-3';
            }
            SingleLocations.generateToken(key, value, 'bath-tokens');
        });
        if (num_baths.length) {
            SingleLocations.updateUrlParam('baths', num_baths.join(','));
        } else {
            SingleLocations.removeUrlParam('baths');
        }

        return false;
    },
    resetBaths(map) {
        $('.bath-check .advanced-filter-facet').removeClass('is-active');
        $('.bath-check .advanced-filter-facet').removeClass('is-active');
        SingleLocations.removeUrlParam('baths');
    },
    filterFeatures(map) {
        SingleLocations.moreFilterCount = 0;
        var community = [];
        $('.community-amenity-filter .advanced-filter-facet').each(function () {
            if ($(this).hasClass('is-active')) {
                community.push($(this).data('value'));
                SingleLocations.moreFilterCount =
                    SingleLocations.moreFilterCount + 1;
            }
        });
        communityFeatures = community;
        if (community.length > 0) {
            SingleLocations.updateUrlParam(
                'community',
                encodeURIComponent(community.join('!'))
            );
        } else {
            SingleLocations.removeUrlParam('community');
        }

        var apartment = [];
        $('.apartment-amenity-filter .advanced-filter-facet').each(function () {
            if ($(this).hasClass('is-active')) {
                apartment.push($(this).data('value'));
                SingleLocations.moreFilterCount =
                    SingleLocations.moreFilterCount + 1;
            }
        });
        apartmentFeatures = apartment;
        if (apartment.length > 0) {
            SingleLocations.updateUrlParam(
                'apartment',
                encodeURIComponent(apartment.join('!'))
            );
        } else {
            SingleLocations.removeUrlParam('apartment');
        }

        if (SingleLocations.moreFilterCount != 0) {
            SingleLocations.generateToken('more', 'More Filters');
        } else {
            if ($('#search-token-more').length) {
                $('#search-token-more').remove();
            }
        }

        return false;
    },
    resetFeatures(map) {
        communityFeatures = [];
        apartmentFeatures = [];
        var comm_count = $(
            '.community-amenity-filter .advanced-filter-facet'
        ).length;
        var apt_count = $(
            '.apartment-amenity-filter .advanced-filter-facet'
        ).length;
        $('.community-amenity-filter .advanced-filter-facet').removeClass(
            'is-active'
        );
        $('.apartment-amenity-filter .advanced-filter-facet').removeClass(
            'is-active'
        );
        SingleLocations.removeUrlParam('community');
        SingleLocations.removeUrlParam('apartment');
    },
    commutePin: false,
    filterCommute(map) {
        if ($('#commute-slider').length < 1) return;

        // SLIDER
        var slider = document.getElementById('commute-slider');
        var filterRadius = document.getElementById('filter-radius');
        var min = 1;
        var max = 100;
        noUiSlider.create(slider, {
            start: [filterRadius.textContent || 10],
            step: 1,
            connect: 'lower',
            range: {
                min: min,
                max: max,
            },
            format: {
                to: function (value) {
                    return Math.round(value);
                },
                from: function (value) {
                    return Math.round(value);
                },
            },
        });

        // handle interaction
        slider.noUiSlider.on('update', function (values) {
            filterRadius.textContent = values[0];
        });

        // GEOCODER
        var map_bounds = map.getBounds().toArray();
        const boundingBox = [
            map_bounds[0][0],
            map_bounds[0][1],
            map_bounds[1][0],
            map_bounds[1][1],
        ];

        // Add the control to the map.
        const geocoder = new MapboxGeocoder({
            mapboxgl: mapboxgl,
            accessToken: SingleLocations.apiKey,
            country: 'us',
            language: 'en',
            bbox: boundingBox,
            flyTo: false,
            marker: false,
            placeholder: 'Enter an address',
        });

        geocoder.on('result', function (selected) {
            // stash the location
            SingleLocations.commutePin = selected.result;
            $('.mapboxgl-ctrl-geocoder--input').trigger('blur');
        });

        geocoder.on('clear', () => {
            // remove stashed location
            SingleLocations.commutePin = false;
            // remove pin and circle
            SingleLocations.setCommute(map, false);
            // update url (remove lat, lng, radius)
            SingleLocations.removeUrlParam('commute');
            SingleLocations.removeUrlParam('lat');
            SingleLocations.removeUrlParam('lng');
            SingleLocations.removeUrlParam('radius');
            $('#geocoder').find('input[type="text"]').val('');
            // re-center map
            SingleLocations.centerMap(map);

            $('#search-token-near-by').remove();
        });

        // connect to map
        $('#geocoder').append(geocoder.onAdd(map));

        // handle apply
        $('[data-filter=commute] .search-filter__apply').on(
            'click',
            function () {
                $('.search-filter-toggle').removeClass('is-open');
                $('.search-filter').attr('open', false);

                if (SingleLocations.commutePin) {
                    $('.search-filter-toggle[data-filter=commute]').addClass(
                        'is-active'
                    );

                    // get radius
                    var radius = Math.round(
                        $('#commute-slider .noUi-handle').attr('aria-valuenow')
                    );
                    // add it to the url
                    SingleLocations.updateUrlParam(
                        'commute',
                        encodeURIComponent(
                            SingleLocations.commutePin.place_name
                        )
                    );
                    SingleLocations.updateUrlParam(
                        'lng',
                        SingleLocations.commutePin.geometry.coordinates[0]
                    );
                    SingleLocations.updateUrlParam(
                        'lat',
                        SingleLocations.commutePin.geometry.coordinates[1]
                    );
                    SingleLocations.updateUrlParam('radius', radius);
                    currentFilterRadius = radius;

                    // draw circle
                    SingleLocations.setCommute(map, SingleLocations.commutePin);
                    SingleLocations.runFilterBasedOnURL(map);
                    // SingleLocations.generateToken('more', "More Filters")
                    SingleLocations.generateToken('near-by', radius + ' Miles');
                }
                console.log($('.search-filter-toggle[data-filter=commute] a'));
                $('.search-filter-toggle[data-filter=commute] a').focus();
                return false;
            }
        );

        // handle reset
        $('[data-filter=commute] .search-filter__reset').on(
            'click',
            function () {
                SingleLocations.resetCommute(map);
                SingleLocations.runFilterBasedOnURL(map);
                return false;
            }
        );

        // on load, set the location from the url
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const starting_location = urlParams.get('commute');
        if (starting_location) {
            const loaded_query = geocoder.query(starting_location);
            loaded_query.on('result', function () {
                $('[data-filter=commute] .search-filter__apply').trigger(
                    'click'
                );
                setTimeout(function () {
                    $('[data-filter=commute] .suggestions').empty().hide();
                }, 10);
            });
        }
    },
    setCommute(map, location) {
        // clear circle
        var circleLayer = map.getLayer('circleFill');
        if (typeof circleLayer !== 'undefined') {
            map.removeLayer('circleFill').removeSource('circleData');
        }
        // clear pin
        var nearbyPin = map.getLayer('nearbyPin');
        if (typeof nearbyPin !== 'undefined') {
            map.removeLayer('nearbyPin').removeSource('nearbyPin');
        }

        if (location) {
            const center = location.geometry;
            const radius = Math.round($('#filter-radius').text()) || 10;
            const options = {
                units: 'miles',
            };
            const circle = turf.circle(center, radius, options);

            map.addSource('circleData', {
                type: 'geojson',
                data: circle,
            });
            map.addLayer({
                id: 'circleFill',
                type: 'fill',
                source: 'circleData',
                paint: {
                    'fill-color': '#006BA1',
                    'fill-opacity': 0.2,
                },
            });

            // zoom to fit circle
            var bbox = turf.bbox(circle);
            map.fitBounds(
                [
                    [bbox[0], bbox[1]],
                    [bbox[2], bbox[3]],
                ],
                {
                    padding: 100,
                    duration: 0,
                }
            );

            // drop pin
            map.addSource('nearbyPin', {
                type: 'geojson',
                data: {
                    type: 'FeatureCollection',
                    features: [
                        {
                            type: 'Feature',
                            geometry: center,
                        },
                    ],
                },
            });
            map.addLayer({
                id: 'nearbyPin',
                type: 'symbol',
                source: 'nearbyPin',
                layout: {
                    'icon-image': 'marker-coral',
                    'icon-size': 0.5,
                    'icon-allow-overlap': true,
                },
            });
        } else {
            SingleLocations.centerMap(map);
            $('.mapboxgl-ctrl-geocoder--input').text('');
        }
    },
    resetCommute(map) {
        // reset radius
        var slider = document.getElementById('commute-slider');
        slider.noUiSlider.set(10);

        // remove commute
        SingleLocations.setCommute(map, false);
        const clear_btn = $(
            '.mapboxgl-ctrl-geocoder--button[aria-label="Clear"]'
        );
        if (clear_btn.length > 0) {
            clear_btn.trigger('click');
        }

        // update ctrls
        $('[data-filter=commute]').removeClass('is-active');
        SingleLocations.removeUrlParam('commute');
        SingleLocations.removeUrlParam('lat');
        SingleLocations.removeUrlParam('lng');
        SingleLocations.removeUrlParam('radius');

        SingleLocations.commutePin = false;
        $('#search-token-near-by').remove();
    },
    generateToken(id, data, commonClass = '') {
        if (!$('.in-page-search-filter').length) {
            if (id == 'more') {
                var count = SingleLocations.moreFilterCount;

                data = data + ' (' + count + ')';
            }
            if ($('#search-token-' + id).length) {
                $('#search-token-' + id).remove();
            }
            var copiedToken = $('#search-token-dummy').clone();
            copiedToken.attr('id', 'search-token-' + id);
            if (commonClass.length) {
                copiedToken.addClass(commonClass);
            }
            copiedToken.find('#token-text').text(data);
            copiedToken.find('.token-close-cta').attr('id', 'close-cta-' + id);
            copiedToken.find('.token-close-cta').attr('data-value', id);
            copiedToken.css('display', 'flex');
            $('.tokens-wrapper .token-div').append(copiedToken);
        }
    },
    resetToken(map) {
        if (!$('.in-page-search-filter').length) {
            $('.tokens-wrapper').on('click', function (e) {
                if ($(e.target).hasClass('token-cls-pth')) {
                    $(e.target).parent().trigger('click');
                    return false;
                }
                if ($(e.target).hasClass('token-close-cta')) {
                    $(e.target).find('svg').trigger('click');
                    return false;
                }
                if ($(e.target).parent().hasClass('token-close-cta')) {
                    var tokenToRemove = $(e.target).parent().data('value');
                    if (tokenToRemove == 'date') {
                        SingleLocations.resetDate();
                    }
                    if (tokenToRemove == 'price') {
                        SingleLocations.resetPrice();
                    }
                    if (tokenToRemove == 'more') {
                        // SingleLocations.resetCommute(map);
                        SingleLocations.resetFeatures(map);
                        // SingleLocations.resetBaths(map);
                        SingleLocations.moreFilterCount = 0;
                    }
                    if (tokenToRemove == 'near-by') {
                        SingleLocations.resetCommute(map);
                    }
                    if (tokenToRemove.indexOf('bed-') !== -1) {
                        var valueArray = tokenToRemove.split('-');
                        $(
                            '.bed-check [data-value="' + valueArray[1] + '"]'
                        ).removeClass('is-active');
                        var _facetVal = valueArray[1];
                        if (valueArray[1] == 3 || valueArray[1] == 4) {
                            _facetVal = 3;
                        }
                        $(
                            '.facet-cards-div .bed-filter-check[data-value="' +
                                _facetVal +
                                '"]'
                        ).removeClass('is-active');

                        var checkedBed = $(
                            '.search-filter .bed-check .is-active'
                        );
                        var num_beds = [];
                        checkedBed.each(function () {
                            num_beds.push($(this).data('value'));
                            var value = '';
                            var key = '';
                            if ($(this).data('value') == 'studio') {
                                value = 'Studio';
                                key = 'bed-studio';
                            } else {
                                value = $(this).data('value') + ' Bed';
                                key = 'bed-' + $(this).data('value');
                            }
                        });
                        if (num_beds.length) {
                            $(
                                '.search-filter-toggle[data-filter=beds]'
                            ).addClass('is-active');
                            SingleLocations.updateUrlParam(
                                'beds',
                                num_beds.join(',')
                            );
                        } else {
                            SingleLocations.removeUrlParam('beds');
                        }
                    }
                    if (tokenToRemove.indexOf('bath-') !== -1) {
                        var valueArray = tokenToRemove.split('-');
                        $(
                            '.bath-check [data-value="' + valueArray[1] + '"]'
                        ).removeClass('is-active');
                        var checkedBath = $('.bath-check .is-active');
                        var num_baths = [];
                        checkedBath.each(function () {
                            num_baths.push($(this).data('value'));
                            var value = '';
                            var key = '';
                            value = $(this).data('value') + ' Bath';
                            key = 'bath-' + $(this).data('value');
                        });
                        if (num_baths.length) {
                            $(
                                '.search-filter-toggle[data-filter=baths]'
                            ).addClass('is-active');
                            SingleLocations.updateUrlParam(
                                'baths',
                                num_baths.join(',')
                            );
                        } else {
                            SingleLocations.removeUrlParam('baths');
                        }
                    }
                    $('#search-token-' + tokenToRemove).remove();

                    SingleLocations.runFilterBasedOnURL(map);
                    return false;
                }
            });
        }
    },
    updateSort(map) {
        $('#sort-result').on('change', function () {
            SingleLocations.updateUrlParam('order', $(this).val());
            location.reload();
        });
    },
    advancedApply(map) {
        $('.advanced-apply').on('click', function () {
            $('.search-filter-toggle').removeClass('is-open');
            $('.search-filter').attr('open', false);
            var checkedBed = $('.search-filter .bed-check .is-active');
            var num_beds = [];
            $('.bed-tokens').remove();
            checkedBed.each(function () {
                num_beds.push($(this).data('value'));
                var value = '';
                var key = '';
                if ($(this).data('value') == 'studio') {
                    value = 'Studio';
                    key = 'bed-studio';
                } else if ($(this).data('value') == '3') {
                    value = '3+ Beds';
                    key = 'bed-3';
                } else {
                    if ($(this).data('value') == '1') {
                        value = $(this).data('value') + ' Bed';
                    } else {
                        value = $(this).data('value') + ' Beds';
                    }
                    key = 'bed-' + $(this).data('value');
                }
                SingleLocations.generateToken(key, value, 'bed-tokens');
            });
            if (num_beds.length) {
                $('.search-filter-toggle[data-filter=beds]').addClass(
                    'is-active'
                );
                SingleLocations.updateUrlParam('beds', num_beds.join(','));
            } else {
                SingleLocations.removeUrlParam('beds');
            }
            SingleLocations.filterFeatures(map);
            SingleLocations.filterBaths(map);
            SingleLocations.runFilterBasedOnURL(map);
            $('#modal-more-filters').hide();
            $('body').removeClass('hide-overflow fixed');
            $('.search-filter').attr('open', false);

            console.log(
                $('.search-filter-toggle[data-filter=more-filters] button')
            );
            $('.search-filter-toggle[data-filter=more-filters] button').focus();
        });
    },
    clearFilters(map) {
        $('.search-filter__reset-all').on('click', function () {
            $('.facet-cards-div .bed-filter-check').removeClass('is-active');
            SingleLocations.resetPrice();
            SingleLocations.resetDate();
            SingleLocations.resetBeds();
            SingleLocations.resetFeatures(map);
            SingleLocations.resetCommute(map);
            SingleLocations.resetBaths(map);
            SingleLocations.removeUrlParam('_page');
            $('#curPage').val(1);
            $('.mapboxgl-popup-close-button').trigger('click');
            $(
                '.tokens-wrapper .search-token:not(#search-token-dummy)'
            ).remove();
            SingleLocations.runFilterBasedOnURL(map);
            SingleLocations.moreFilterCount = 0;
            return false;
        });
    },
    updateLocations(map, property_ids, page = 1) {
        var prop_count = 0;
        // update list
        var page_prop_cnt = 0;
        var perPage = $('#perPage').val();
        $('.location-property-list .a-property').parent().addClass('hidden');
        $('.location-property-list .a-property').each(function () {
            var prop_id = $(this).attr('data-id');
            if (property_ids.includes(parseInt(prop_id))) {
                if (page * perPage > page_prop_cnt) {
                    $(this).parent().removeClass('hidden');
                    page_prop_cnt = page_prop_cnt + 1;
                }
                prop_count = prop_count + 1;
            } else {
                $(this).parent().addClass('hidden');
            }
        });

        map.setLayoutProperty('windsor_properties', 'visibility', 'visible');
        var hasProperties = false;
        setTimeout(() => {
            $('.location-property-list .a-property-wrap').each(function () {
                if ($(this).is(':visible')) {
                    hasProperties = true;
                }
            });

            if (hasProperties) {
                $('.no-location-properties').addClass('hidden');
            } else {
                $('.no-location-properties').removeClass('hidden');
            }
        }, 700);

        if (prop_count >= perPage && page_prop_cnt >= perPage) {
            $('#cur-count').text('1 - ' + page_prop_cnt);
            $('#tot-count').text(prop_count);
            $('#sort-result').prop('disabled', false);
            if (prop_count == page_prop_cnt) $('.property-load-more').hide();
            else $('.property-load-more').show();
        } else {
            if (page_prop_cnt == 1 || page_prop_cnt == 0) {
                $('#cur-count').text(page_prop_cnt);
            } else {
                $('#cur-count').text('1 - ' + page_prop_cnt);
            }
            $('#tot-count').text(page_prop_cnt);
            if (page_prop_cnt == 0) {
                $('#sort-result').prop('disabled', true);
            } else {
                $('#sort-result').prop('disabled', false);
            }
            $('.property-load-more').hide();
        }
    },
    init() {
        const datapicker = document.getElementById('date-filter');

        if (typeof datapicker != 'undefined' && datapicker != null) {
            new Datepicker(datapicker, {
                autohide: true,
                todayHighlight: true,
                minDate: new Date(),
            });
        }

        SingleLocations.jumpLinks();
        SingleLocations.poiSlider();
        SingleLocations.toggleFilter();
        SingleLocations.filterByBeds();
        SingleLocations.closeMapPopup();

        if ($('#locations-map').length < 1) return;

        SingleLocations.setMapHeight();

        setTimeout(() => {
            var center = [-74.5, 40];
            if (
                $('#locations-map').data('lng') &&
                $('#locations-map').data('lat')
            ) {
                SingleLocations.center = [
                    $('#locations-map').data('lng'),
                    $('#locations-map').data('lat'),
                ];
                center = SingleLocations.center;
            }
            mapboxgl.accessToken = SingleLocations.apiKey;
            const map = new mapboxgl.Map({
                container: 'locations-map', // container ID
                style: 'mapbox://styles/mapbox/streets-v11', // style URL
                center: center, // starting position [lng, lat]
                zoom: 9, // starting zoom
            });
            // disable map zoom when using scroll
            map.scrollZoom.disable();
            map.addControl(new mapboxgl.NavigationControl());
            //Disable map from screenreader
            $(
                '.mapboxgl-canvas, .mapboxgl-ctrl-logo, .mapboxgl-ctrl-group button, .mapboxgl-ctrl-attrib-inner a'
            ).attr('aria-hidden', 'true');
            $('.mapboxgl-ctrl-attrib-inner').removeAttr('role');
            $(
                '.mapboxgl-canvas, .mapboxgl-ctrl-logo, .mapboxgl-ctrl-group button, .mapboxgl-ctrl-attrib-inner a'
            ).attr('tabindex', '-1');
            map.on('load', function () {
                SingleLocations.populateMap(map);
                SingleLocations.centerMap(map);
                $(
                    '.mapboxgl-canvas, .mapboxgl-ctrl-logo, .mapboxgl-ctrl-group button, .mapboxgl-ctrl-attrib-inner a'
                ).attr('aria-hidden', 'true');
                $('.mapboxgl-ctrl-attrib-inner').removeAttr('role');
                $(
                    '.mapboxgl-canvas, .mapboxgl-ctrl-logo, .mapboxgl-ctrl-group button, .mapboxgl-ctrl-attrib-inner a'
                ).attr('tabindex', '-1');
            });

            map.once('idle', function () {
                SingleLocations.updateLocations(
                    map,
                    window.filtered_properties
                );
                SingleLocations.hideLoader();

                SingleLocations.filterPrice(map);
                SingleLocations.filterDate(map);
                SingleLocations.filterBeds(map);
                SingleLocations.filterCommute(map);
                SingleLocations.clearFilters(map);
                SingleLocations.resetToken(map);
                SingleLocations.updateFilterCount();
                SingleLocations.updateSort(map);
                SingleLocations.runFilterBasedOnURL(map);
                SingleLocations.advancedApply(map);

                map.resize();
                SingleLocations.centerMap(map);
                $('#locations-map').css('opacity', 1);

                $(window).on('load resize', function () {
                    SingleLocations.setMapHeight();
                    map.resize();
                    SingleLocations.centerMap(map);
                });
            });
        }, 5000);
    },
};

// export default SingleLocations;
